export enum DivMinuteEnum {
  Minute = 0,
  Media = 1,
  Analytic = 7,
  Image = 3,
  Empty = 0
}
export enum DivChartEnum {
  Chart = 0,
  MedComp = 1,
  Empty = 2,
  Image = 3,
  Analytic = 7
}
export enum SelectTypeGridEnum {
  Both = 0,
  Minute = 1,
  Empty = 2,
  Image = 3,
  Chart = 4,
  None = 5,
  Analytic = 7
}
